export default __webpack_public_path__ + "static/media/platinum1.644a33f9.svg";